import { useLocation } from "@reach/router";
import { graphql, useStaticQuery } from "gatsby";
import React, { ReactElement, useContext, useEffect } from "react";
import Context from "../context/Context";
import { HeadProps } from "./interfaces";

const SEO = (props: HeadProps): ReactElement => {
  // const data = useContext(Context);
  // const { setActiveLink } = data;
  // useEffect(() => {
  //   setActiveLink(props.title);
  // }, []);

  const { pathname } = useLocation();
  const { site } = useStaticQuery(query);
  const {
    defaultTitle,
    defaultImage,
    defaultDescription,
    siteUrl,
    twitterUsername,
    twitterImage,
    favicon,
  } = site.siteMetadata;
  const seo = {
    title: props.title ? `${defaultTitle} | ${props.title}` : defaultTitle,
    description: props.description || defaultDescription,
    image: props.image || defaultImage,
    twitterImage: twitterImage || defaultImage,
    url: `${siteUrl}${pathname}`,
  };
  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <link
        rel="icon"
        type="image/png"
        href="https://sng-client-assets.s3.amazonaws.com/fedscoop/favicons/favicon-fs.png"
        media="(prefers-color-scheme: light)"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://sng-client-assets.s3.amazonaws.com/fedscoop/favicons/favicon-fs-darkmode.png"
        media="(prefers-color-scheme: dark)"
      />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.url && <link rel="canonical" href={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.twitterImage && (
        <meta property="og:image" content={seo.twitterImage} />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.twitterImage && (
        <meta name="twitter:image" content={seo.twitterImage} />
      )}
      <link rel="stylesheet" href="https://use.typekit.net/vck7vce.css" />
      {props.children}
    </>
  );
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        defaultImage: image
        defaultDescription: description
        siteUrl: url
        twitterUsername
        twitterImage
        favicon
      }
    }
  }
`;

export default SEO;
